import React, { useState } from "react";
import api from "../api/client";

export default function Login({ onLogin, agencyMode }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login/", {
        username,
        password,
        agency_mode: !!agencyMode,
      });
      localStorage.setItem("access_token", data.access);
      localStorage.setItem("refresh_token", data.refresh);
      if (data.is_agency_admin !== undefined) {
        localStorage.setItem("is_agency_admin", data.is_agency_admin ? "1" : "0");
      }
      onLogin();
    } catch (err) {
      const resp = err.response;
      if (resp?.status === 403 && resp?.data?.error) {
        // Agency admin access denied
        setError(resp.data.error);
      } else if (resp?.status === 401) {
        setError(resp?.data?.error || "Invalid username or password");
      } else {
        // Fallback to legacy JWT endpoint
        try {
          const { data } = await api.post("/token/", { username, password });
          localStorage.setItem("access_token", data.access);
          localStorage.setItem("refresh_token", data.refresh);
          onLogin();
          return;
        } catch {
          setError("Invalid username or password");
        }
      }
    } finally {
      setLoading(false);
    }
  };

  if (agencyMode) {
    return (
      <div className="min-h-screen bg-dark flex items-center justify-center px-4">
        <div className="bg-dark-300 border border-dark-50 rounded-2xl p-8 w-full max-w-sm space-y-6">
          <div className="text-center">
            <h1 className="text-2xl font-bold font-mono tracking-tight">
              <span className="text-gold">Onesuite</span>
              <span className="text-white">SEO</span>
            </h1>
            <p className="text-xs text-gold/60 uppercase tracking-widest mt-1">Agency Admin</p>
            <p className="text-sm text-gray-500 mt-3">Sign in to manage your agency</p>
          </div>
          {error && (
            <div className="bg-red-900/20 border border-red-800/30 rounded-lg px-4 py-2.5 text-sm text-red-400">
              {error}
            </div>
          )}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm text-gray-400 mb-1">Username or Email</label>
              <input
                type="text" value={username} onChange={(e) => setUsername(e.target.value)}
                autoFocus required
                className="w-full bg-dark border border-dark-50 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-gold/50"
              />
            </div>
            <div>
              <label className="block text-sm text-gray-400 mb-1">Password</label>
              <input
                type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full bg-dark border border-dark-50 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-gold/50"
              />
            </div>
            <button
              type="submit" disabled={loading}
              className="w-full py-2.5 bg-gold hover:bg-gold-600 text-dark rounded-lg text-sm font-bold disabled:opacity-50"
            >
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <h1 className="login-logo">
          <span style={{ color: "#b87333" }}>Onesuite</span><span>SEO</span>
        </h1>
        <p className="login-subtitle">Sign in to your dashboard</p>
        {error && <div className="login-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="login-field">
            <label>Username or Email</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
              required
            />
          </div>
          <div className="login-field">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
